/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditsmonthly1Inputs */

const en_creditsmonthly1 = /** @type {(inputs: Creditsmonthly1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits every month`)
};

const de_creditsmonthly1 = /** @type {(inputs: Creditsmonthly1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits jeden Monat`)
};

/**
* | output |
* | --- |
* | "Credits every month" |
*
* @param {Creditsmonthly1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditsmonthly1 = /** @type {((inputs?: Creditsmonthly1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditsmonthly1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditsmonthly1(inputs)
	return de_creditsmonthly1(inputs)
});
export { creditsmonthly1 as "creditsMonthly" }